import Gateway from '@nsftx/seven-gravity-gateway';
import config from '../../../config';

let gateway;
let storeDispatch;
export default {
  init({ dispatch }) {
    storeDispatch = dispatch;
    const gatewayConstructor = Gateway.slave;
    gateway = gatewayConstructor({
      debug: true,
      slaveId: 'PreMatchBetting',
      productId: 'PreMatchBetting',
      eventPropagation: {
        click: true,
        keydown: '*',
      },
      data: {
        title: 'Prematch betting client',
      },
      load: ({ data }) => {
        const {
          company, terminal, device, betslip, settings, user, locale,
        } = data;
        const balance = terminal && terminal.balance ? terminal.balance : device.balance;

        const moneyDenominations = settings && settings.moneyDenominations
          ? settings.moneyDenominations
          : [];

        storeDispatch('setMoneyDenominations', moneyDenominations);
        storeDispatch('setOddType', settings.oddType || 1);
        storeDispatch('updateBalance', balance);
        storeDispatch('setDeviceData', {
          name: device.name,
          deviceUuid: device.deviceUuid,
          uuid: device.uuid,
        });

        storeDispatch('setCompanyData', {
          currency: company.currency,
          locale: locale.iso1 || company.locale,
          name: company.name,
          uuid: company.uuid,
        });

        storeDispatch('setEnv', data.ENV);

        storeDispatch('setUserType', user.type);

        const companyConfig = config;

        if (companyConfig.companies[company.uuid]) {
          companyConfig.appSettings = _.merge(
            companyConfig.appSettings,
            companyConfig.companies[company.uuid].appSettings,
          );
        }

        storeDispatch('setCompanyConfig', companyConfig.appSettings);

        const tabs = _.filter(_.sortBy(companyConfig.appSettings.ticket.tabs, ['position']), { disabled: false });
        const defaultType = companyConfig.appSettings.ticket.activeType;

        storeDispatch('setTicketType', parseInt(defaultType, 10));
        storeDispatch('setBetslipTabs', tabs);

        storeDispatch('loadCpvUuid', data.product.cpvUuid);
        storeDispatch('initApp');

        storeDispatch('setWorkingTimeBlocker', (betslip || {}).blockers || []);
      },
      shown: (data) => {
        console.log('iframe shown => ', data);
      },
    });
    this.setListeners();
  },
  sendMessage(action, data, enforce) {
    const gatewayDataConstruct = {
      action,
      data,
    };
    if (enforce) {
      gatewayDataConstruct.enforceEvent = true;
    }
    if (gateway) gateway.sendMessage(gatewayDataConstruct);
  },
  emitAsync(action, data) {
    const gatewayDataConstruct = { action, data };

    return gateway.emitAsync(gatewayDataConstruct);
  },
  setListeners() {
    gateway.on('Slave.Shown', () => {
      storeDispatch('iframeShown');
    });

    gateway.on('UI.Show', ({ data }) => {
      storeDispatch('handleUIShowEvent', data);
    });

    gateway.on('Tickets.PayingSuccess', (data) => {
      console.log('Tickets.PayingSuccess => ', data);
    });

    gateway.on('Widget.SettingsChanged', ({ data }) => {
      storeDispatch('setOddType', data.oddType || 1);
    });

    gateway.on('Tickets.ReBet', ({ data }) => {
      storeDispatch('ticketRebet', data.ticket);
    });

    gateway.on('Betslip.TicketActivated', (data) => {
      console.log('Betslip.TicketActivated => ', data);
    });

    gateway.on('User.BalanceChanged', ({ data }) => {
      storeDispatch('updateBalance', data.balance);
    });

    // Alternative stake
    gateway.on('Widget.Event', ({ data }) => {
      if (data.action.id === 'acceptAlternativeStake') {
        storeDispatch('updateStake', { alternativeStake: true });
      }
    });

    gateway.on('Ticket.CheckWebCode', ({ data }) => {
      storeDispatch('generateWebTicket', data.code);
    });

    gateway.on('Tickets.PrePrint', ({ data }) => {
      storeDispatch('printTicket', data).then((printPayload) => {
        this.sendMessage('Tickets.Print', printPayload, true);
      });
    });

    gateway.on('Tickets.Checked', ({ data }) => {
      storeDispatch('setTicketCheck', (data.ticket || {}));
    });

    // gateway.on('Slave.Init', (data) => {
    //   console.log('Data loaded from master app => ', data);
    // });

    gateway.on('Betslip.Blocked', ({ data: { blockers } }) => {
      storeDispatch('setWorkingTimeBlocker', blockers || []);
    });
    gateway.on('Betslip.Unblocked', ({ data: { blockers } }) => {
      storeDispatch('removeWorkingTimeBlocker', blockers || []);
    });
    gateway.on('User.AuthorizationChanged', ({ data }) => {
      storeDispatch('setUserType', data.userType);
    });
  },
};
